<template>
  <BaseAside>
    <template v-slot:title>
      <h1>Disclaimer</h1>
    </template>

    <p>
      The above amount is an estimate of the Registration cost only. There may be additional charges that may apply if
      you choose to register the vehicle. Below are some of these additional charges:
    </p>

    <ol>
      <li>
        <p>
          Title fee: If your vehicle is issued a title an additional title fee will be applicable
        </p>
      </li>
      <li>
        <p>
          Plate fee: If you need a new plate an additional plate fee will be applicable
        </p>
      </li>
      <li>
        <p>
          Charity design fee: If you choose a Charity design an additional Charity surcharge will be applicable
        </p>
      </li>
      <li>
        <p>
          Technology and DOT Surcharge is applicable for all registrations
        </p>
      </li>
    </ol>
    <p>
      Please refer to the
      <BaseLinkOpenNew
          url="https://dmv.ri.gov/registrations-plates-titles/license-plates/plate-fees"
          name="RI DMV Plate Fees" />page for more information.
    </p>
  </BaseAside>
</template>

<script>
import BaseAside from "../../ui/BaseAside"
import BaseLinkOpenNew from "../../ui/BaseLinkOpenNew"

export default {
  name: "EstimateDisclaimer",
  components: {
    BaseAside,
    BaseLinkOpenNew,
  }
}
</script>

<style lang="scss" scoped>
.app-notice {
  max-width: unset;
  margin-block-end: 1em;
  @media print {          // one-off to include Disclaimer
    display: block !important;
    padding: 0 calc(var(--padding-horizontal) * 0.5);
  }
}
ol {
  padding-block-end: 0.75em;
  li {
    p {
      padding: 0.2em 0;
    }
  }
}
</style>
